<div class="admin-layout">
  <app-sidebar></app-sidebar>

  <main class="main-content">
    <app-header></app-header>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
